import { AlertTriangle } from 'lucide-react';

import { REDACTION_BLOCKED_MESSAGES } from '../../constants/redaction';

export default function BlockedNotice({
  reason,
  onDismiss,
}: {
  reason: string;
  onDismiss: () => void;
}) {
  return (
    <div className="mx-6 mt-4 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
      <div className="flex-1 text-sm text-amber-900">
        {REDACTION_BLOCKED_MESSAGES[reason] ??
          'This record cannot be redacted automatically.'}
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="text-xs font-semibold text-amber-800 underline"
      >
        Dismiss
      </button>
    </div>
  );
}
